<template>
  <div :class="['countdown', output ? 'on' : '']">
    <div v-if="showDays" class="countdown-part">
      <i>{{ output.days }}</i>
      <p>days</p>
    </div>
    <div class="countdown-part">
      <i>{{ output.hours }}</i>
      <p>hours</p>
    </div>
    <div class="countdown-part">
      <i>{{ output.minutes }}</i>
      <p>mins</p>
    </div>
    <div class="countdown-part">
      <i>{{ output.seconds }}</i>
      <p>secs</p>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, onUnmounted } from "vue";

const emit = defineEmits(['ended', 'targetTimeReached']);

const props = defineProps({
  // Accept a UTC timestamp in milliseconds (e.g., Date.now() + 60000)
  startTimeUtc: {
    type: Number,
    required: true
  },
  // Optional specific time to trigger an event (e.g., when 10 seconds are left)
  notifyAtSecondsLeft: Number 
});

const currentTime = ref(Date.now());
let timer = null;

const output = computed(() => {
  const diff = props.startTimeUtc - currentTime.value;
  
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / 1000 / 60) % 60),
    seconds: Math.floor((diff / 1000) % 60)
  };
});

const showDays = computed(() => output.value.days > 0);

function updateTimer() {
  currentTime.value = Date.now();
  
  const secondsLeft = Math.floor((props.startTimeUtc - currentTime.value) / 1000);

  // Emit target reached
  if (props.notifyAtSecondsLeft && secondsLeft === props.notifyAtSecondsLeft) {
    emit('targetTimeReached');
  }

  // Check if finished
  if (secondsLeft <= 0) {
    emit('ended');
    stopTimer();
  } else {
    timer = setTimeout(updateTimer, 1000);
  }
}

function stopTimer() {
  if (timer) clearTimeout(timer);
}

onMounted(() => updateTimer());
onUnmounted(() => stopTimer()); // Important: Clean up memory!
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.countdown {
  visibility: hidden;
  display: flex;
  justify-content: center;

  &.on {
    visibility: visible;
  }

  &-part {
    display: inline-block;
    text-align: center;
    margin: 0 3px;

    i {
      background-color: rgba(255, 255, 255, 0.3);
      color: white;
      width: 75px;
      height: 75px;
      border-radius: 5px;
      display: block;
      font-style: normal;
      line-height: 75px;
      font-size: 150%;
    }

    p {
      margin-top: 3px;
    }
  }
}
</style>
